import { BasicValue, FileUpload as BaseFileUpload, Icons } from '@tabeo/scarf'
import handleFileDownload from '@tabeo/sharpei/utils/handleFileDownload'
import React from 'react'
import { useAuth } from 'resources/Auth'
import { useTicket } from 'resources/Ticket'

function FileUpload({ ...rest }) {
  const { resource } = useTicket()
  const {
    data: { token },
  } = useAuth()

  const {
    input: { onFocus, onBlur },
  } = rest

  const { uploadFile, removeFile } = resource

  return (
    <BaseFileUpload
      upload={uploadFile}
      accept=".jpg,.png,.bmp,.gif,.pdf,.txt,.rtf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.xml,.json,.csv,.zip,.rar"
      renderItem={({
        value,
        loading,
        error,
        setLoading,
        setError,
        spacing,
      }) => {
        // eslint-disable-next-line camelcase
        const url = value?.objects?.ticket_file?.url
        const fileId = value?.id
        return (
          <BasicValue
            icon={props => <Icons.Clip {...props} />}
            onClick={() => {
              handleFileDownload(url, { token })
            }}
            invalid={!!error}
            loading={loading}
            onDelete={async e => {
              onFocus()
              e.preventDefault()
              e.stopPropagation()

              try {
                setLoading(true)
                await removeFile(fileId)
              } catch (e) {
                setError(e)
              }
              onBlur()
            }}
            {...spacing}
            _hover={{
              bg: 'sky.3',
            }}
          >
            {loading ? (!url ? 'Uploading...' : 'Deleting...') : value.name}
          </BasicValue>
        )
      }}
      {...rest}
    />
  )
}

export default FileUpload
